<template>
    <div>
        <el-card class="box-card" style="width: 400px">
            <div slot="header" class="clearfix">
                <span>{{user.trueName}}</span>
            </div>
            <div>
                <div style="display: flex;justify-content: center; margin-bottom: 8px;">
                  <el-upload
                            action="/work/user/userface"
                            :headers="headers"
                            :data="admin"
                            :show-file-list="false"
                            :on-success="onSuccess">
                        <img title="点击修改用户图像" :src="user.userFace"
                             style="height: 100px;width: 100px;border-radius: 50px"
                             alt="">
                    </el-upload>
                </div>
                <div class="user-info-container">
                  <div class="info-item">
                    <span class="info-label">邮件地址：</span>
                    <el-tag class="info-tag">{{user.email}}</el-tag>
                  </div>
                  <div class="info-item">
                    <span class="info-label">手机号码：</span>
                    <el-tag class="info-tag">{{user.phone}}</el-tag>
                  </div>
                  <div class="info-item">
                    <span class="info-label">创建时间：</span>
                    <el-tag class="info-tag">{{user.createDate}}</el-tag>
                  </div>
                </div>
          <!--      <div>
                    用户标签：
                    <el-tag style="margin-right: 5px" type="success" v-for="(r,index) in user.roles" :key="index">
                        {{r.nameZh}}
                    </el-tag>
                </div> -->
                <div style="display: flex;justify-content: space-around;margin-top: 10px">
                    <el-button type="primary" @click="showUpdateUserInfoView">修改信息</el-button>
                    <el-button type="danger" @click="showUpdatePasswordVie">修改密码</el-button>
                </div>
            </div>
        </el-card>
      <el-dialog
                title="编辑用户信息"
                :visible.sync="dialogVisible"
                width="30%">
            <div>
                <table>
                    <tr>
                        <td>用户姓名：</td>
                        <td>
                            <el-input v-model="user2.trueName"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>手机号码：</td>
                        <td>
                            <el-input v-model="user2.phone"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>用户邮箱：</td>
                        <td>
                            <el-input v-model="user2.email"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateUserInfo">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog
                title="更新密码"
                :visible.sync="passwordDialogVisible"
                width="30%">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="124px"
                     class="demo-ruleForm">
                <el-form-item label="请输入旧密码" prop="oldPassword">
                    <el-input type="password" v-model="ruleForm.oldPassword" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="请输入新密码" prop="newPassword">
                    <el-input type="password" v-model="ruleForm.newPassword" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="repeatPassword">
                    <el-input type="password" v-model="ruleForm.repeatPassword" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "UserInfo",
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.ruleForm.repeatPassword !== '') {
                        this.$refs.ruleForm.validateField('repeatPassword');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm.newPassword) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                headers: {
                    userIdStr: window.sessionStorage.getItem('userIdStr')
                },
                user: null,
                user2: null,
                dialogVisible: false,
                passwordDialogVisible: false,
                ruleForm: {
                    newPassword: '',
                    repeatPassword: '',
                    oldPassword: '',
                    classRoomUid: sessionStorage.getItem('classRoomUid')
                },
                rules: {
                    newPassword: [
                        {validator: validatePass, trigger: 'blur'}
                    ],
                    repeatPassword: [
                        {validator: validatePass2, trigger: 'blur'}
                    ],
                    oldPassword: [
                        {validator: validatePass, trigger: 'blur'}
                    ]
                }
            }
        },
        mounted() {
            this.initUser();
        },
        methods: {
            onSuccess() {
                this.initUser();
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // 用户id 后端从 HttpServletRequest 中取 
                        this.postRequest2('/user/update_pwd', this.ruleForm).then(resp => {
                            if (resp) {
                                //更新密码成功后退出登录
                                sessionStorage.clear();
                                this.$store.commit('initRoutes', []);
                                this.$router.replace('/');
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            showUpdatePasswordVie() {
                this.passwordDialogVisible = true;
            },
            updateUserInfo() {
                this.postRequest('/user/update', this.user2).then(resp => {
                    if (resp) {
                        this.dialogVisible = false;
                        this.initUser();
                    }
                })
            },
            showUpdateUserInfoView() {
                this.dialogVisible = true
				this.user2 = Object.assign({}, this.user)
            },
            initUser() {
                this.getRequest('/user/info').then(resp => {
                    if (resp) {
						window.sessionStorage.removeItem('user');
                        this.user = resp.result
                        this.user2 = Object.assign({}, this.user)  // 对象拷贝
                        window.sessionStorage.setItem('user', JSON.stringify(resp.result));
                        this.$store.commit('INIT_USER', resp.result);
                    }
                })
            }
        }
    }
</script>

<style scoped>
.user-info-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-item {
  display: flex;
  align-items: center;
}

.info-label {
  width: 80px; /* 调整标签宽度以对齐 */
  font-weight: bold;
  color: #333;
}

.info-tag {
  background-color: #f0f0f0;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 14px;
}
</style>
